/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";
import { Deployment, Deployment$inboundSchema } from "./deployment.js";

export type GetActiveDeploymentResult = {
  deployment?: Deployment | undefined;
};

/** @internal */
export const GetActiveDeploymentResult$inboundSchema: z.ZodMiniType<
  GetActiveDeploymentResult,
  unknown
> = z.object({
  deployment: z.optional(Deployment$inboundSchema),
});

export function getActiveDeploymentResultFromJSON(
  jsonString: string,
): SafeParseResult<GetActiveDeploymentResult, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => GetActiveDeploymentResult$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'GetActiveDeploymentResult' from JSON`,
  );
}
